<template>
  <div
    data-cy="interval-value-editor"
    class="interval-value-editor d-flex flex-row justify-content-between"
    :class="{
      'border-warning': localValidationData && !localValidationData.isValid && localValidationData.type == 'warning',
      'border-danger': localValidationData && !localValidationData.isValid && localValidationData.type == 'error'
    }"
    v-tooltip="localValidationData && !localValidationData.isValid ? localValidationData.feedback : false">
    <input
      type="text"
      ref="lowerLimit"
      v-model.lazy="lowerLimit"
      data-cy="input-lowerlimit-interval-value"
      class="lower-limit form-control flex-grow-1"
      :placeholder="focused ? '' : localvalueOrFallback.lowerLimit"
      :readonly="!canWrite"
      @focus="focused = true"
      @blur="focused = false"
      @keyup.enter="lowerLimit = $refs.lowerLimit.value" />
    <span class="interval-separator">{{ globalParameters.IntervalSeparator }}</span>
    <input
      type="text"
      data-cy="input-upperlimit-interval-value"
      ref="upperLimit"
      class="upper-limit form-control flex-grow-1"
      v-model.lazy="upperLimit"
      :placeholder="focused ? '' : localvalueOrFallback.upperLimit"
      :readonly="!canWrite"
      @focus="focused = true"
      @blur="focused = false"
      @keyup.enter="upperLimit = $refs.upperLimit.value" />
  </div>
</template>
<script>
import { mapState } from "vuex";
import authorizationProvider from "@services/permissions/permissionEngine.js";

export default {
  props: ["value", "valueOrFallback", "language", "validationData", "authorizationContext"],
  data() {
    return {
      localValue: "",
      lowerLimit: "",
      upperLimit: "",
      focused: false
    };
  },
  computed: {
    ...mapState(["globalParameters"]),
    canWrite() {
      if (this.authorizationContext) {
        return authorizationProvider.canWrite(this.authorizationContext);
      }
      return true;
    },
    localvalueOrFallback() {
      if (!this.valueOrFallback) return { lowerLimit: "", upperLimit: "", isFallback: false };

      if (this.localValue)
        return {
          lowerLimit: this.lowerLimit,
          upperLimit: this.upperLimit,
          isFallback: false
        };

      if (this.valueOrFallback) {
        const intervalValue = this.valueOrFallback.split(this.globalParameters.IntervalSeparator);
        if (intervalValue) {
          return {
            lowerLimit: intervalValue[0] ? intervalValue[0] : "",
            upperLimit: intervalValue[1] ? intervalValue[1] : "",
            isFallback: true
          };
        }
      }

      return { lowerLimit: "", upperLimit: "", isFallback: false };
    },
    localValidationData() {
      if (this.validationData && !this.validationData.isValid && this.validationData.type == "error") {
        return this.validationData;
      } else if (this.dataTypeValidationData) return this.dataTypeValidationData;
      else return this.validationData;
    },
    dataTypeValidationData() {
      if (!this.localValue) return null;

      const items = this.localValue.split(this.globalParameters.IntervalSeparator);
      if (items.length != 2) {
        return {
          isValid: false,
          feedback: this.$t("validation.dataTypeNotInterval"),
          type: "warning"
        };
      }
      const decimalSeparator = this.language.decimalSeparator;
      const groupSeparator = this.language.groupSeparator;
      let validationResponse = this.validateNumeric(this.lowerLimit, groupSeparator, decimalSeparator);

      if (!validationResponse) {
        validationResponse = this.validateNumeric(this.upperLimit, groupSeparator, decimalSeparator);
      }

      return validationResponse ? validationResponse : null;
    }
  },
  methods: {
    validateNumeric(val, groupSaparator, decimalSeparator) {
      if (val && val != "") {
        if (groupSaparator != "" && val.indexOf(groupSaparator) > -1) {
          return {
            isValid: false,
            feedback: this.$t("valueNotTypeNumeric"),
            type: "warning"
          };
        } else {
          const number = val.replace(decimalSeparator, ".");
          if (isNaN(number) || number != parseFloat(number)) {
            return {
              isValid: false,
              feedback: this.$t("valueNotTypeNumeric"),
              type: "warning"
            };
          }
        }
      }
      return null;
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(nv) {
        if (nv != this.localValue) {
          this.localValue = nv;
          const intervalValue = this.localValue ? this.localValue.split(this.globalParameters.IntervalSeparator) : null;
          if (intervalValue) {
            if (intervalValue[0]) {
              this.lowerLimit = intervalValue[0];
            } else {
              this.lowerLimit = "";
            }
            if (intervalValue[1]) {
              this.upperLimit = intervalValue[1];
            } else {
              this.upperLimit = "";
            }
          }
        }
      }
    },
    lowerLimit(nv) {
      this.localValue = nv + this.globalParameters.IntervalSeparator + this.upperLimit;
      this.$emit("input", this.localValue);
    },
    upperLimit(nv) {
      this.localValue = this.lowerLimit + this.globalParameters.IntervalSeparator + nv;
      this.$emit("input", this.localValue);
    }
  }
};
</script>
